"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useClipboard;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));

// Inspired from https://github.com/mantinedev/mantine/blob/master/src/mantine-hooks/src/use-clipboard/use-clipboard.ts
function useClipboard() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 2000 : _ref$timeout;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      copied = _useState4[0],
      setCopied = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      copyTimeout = _useState6[0],
      setCopyTimeout = _useState6[1];

  var handleCopyResult = function handleCopyResult(value) {
    clearTimeout(copyTimeout);
    setCopyTimeout(setTimeout(function () {
      return setCopied(false);
    }, timeout));
    setCopied(value);
  };

  var copy = function copy(valueToCopy) {
    if (!(0, _isNil.default)(navigator.clipboard)) {
      navigator.clipboard.writeText(valueToCopy).then(function () {
        return handleCopyResult(true);
      }).catch(function (err) {
        return setError(err);
      });
    } else {
      setError(new Error('useClipboard: navigator.clipboard is not supported'));
    }
  };

  var reset = function reset() {
    setCopied(false);
    setError(null);
    clearTimeout(copyTimeout);
  };

  return {
    copy: copy,
    reset: reset,
    error: error,
    copied: copied
  };
}